import './index.scss'

import { ErrorBoundaryFallbackComponent } from '@components/ErrorBoundaryFallbackComponent'
// import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'

import App from './App.tsx'

// Sentry.init({
//   dsn: 'https://07fa2dbc34999f9de1264cbc668eb9f8@o4509130082287616.ingest.us.sentry.io/4509130086023168',
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration()
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })

createRoot(document.getElementById('app_quiz')!).render(
  <StrictMode>
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallbackComponent}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
